export function getItemState(isDisabled: boolean, isSelected: boolean, isHovered: boolean) {
  return isDisabled ? "disabled" : isSelected ? "selected" : isHovered ? "hover" : "default";
}
